import React, { type FC, useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';

type ChartCompareKeyProps = {
    algorithm: 'st' | 'marquette';
};

const ChartCompareKey: FC<ChartCompareKeyProps> = ({ algorithm }) => {
    const panel = useRef<OverlayPanel>(null);
    return (
        <>
            <button
                type="button"
                className="btn btn-primary mt-8 mb-4"
                onClick={(event) => panel.current?.toggle?.(event)}
            >
                Key
            </button>
            <OverlayPanel ref={panel}>
                <div className="flex flex-col gap-2">
                    <KeyRow
                        label="heavy menstruation"
                        className="bg-heavyBleeding"
                    />
                    <KeyRow
                        label="light menstruation"
                        className="bg-lightBleeding"
                    />
                    <KeyRow label="spotting" className="bg-spotting" />
                    {algorithm === 'st' && (
                        <>
                            <KeyRow
                                label="more fertile mucus"
                                className="bg-moreFertile"
                            />
                            <KeyRow
                                label="less fertile mucus"
                                className="bg-lessFertile"
                            />
                            <KeyRow label="peak day" symbol="P" />
                            <KeyRow
                                label="no mucus"
                                className="bg-notFertile"
                            />
                        </>
                    )}
                    {algorithm === 'marquette' && (
                        <>
                            <KeyRow label="less fertile" symbol="L" />
                            <KeyRow label="more fertile" symbol="H" />
                            <KeyRow label="peak fertility" symbol="☺" />
                        </>
                    )}
                    <KeyRow
                        label="no data"
                        className="border-purple border-2"
                    />
                </div>
            </OverlayPanel>
        </>
    );
};

type KeyRowProps = {
    symbol?: string;
    label: string;
    className?: string;
};

const KeyRow: FC<KeyRowProps> = ({ symbol, label, className }) => {
    return (
        <div className="flex flex-row gap-8">
            <div
                className={`h-8 w-24 text-primary flex items-center justify-center ${
                    className ?? ''
                }`}
            >
                {symbol}
            </div>
            <div className="text-primary">{label}</div>
        </div>
    );
};

export default ChartCompareKey;
